import { LastExpeditionStatusEnum } from '../api/ringil-api.v2';
import {
  dayjsFromApiPrague,
  dayjsFromApiUtcInTz,
  formatDateTimeFromDayjsInTzWithLocale, stringDateTimeWithLocaleFromApiStringInTz,
} from '@utils/dateWithTz.tsx';
import { isNotNullOrUndefined, isNullOrUndefined } from './utils';
import { dateFormatDateTime, mapFromAPIDateTime } from '@utils/date.tsx';

export const isExpeditionActiveByLast = (lastExpeditionState: LastExpeditionStatusEnum) => {
  switch (lastExpeditionState) {
    case LastExpeditionStatusEnum.READY_TO_SHIPMENT:
      return true;
    case LastExpeditionStatusEnum.ACTIVE:
      return true;
    case LastExpeditionStatusEnum.WAITING_FOR_DOCS:
      return true;
    case LastExpeditionStatusEnum.FINISHED:
      return true;
    default:
      return false;
  }
};

export const resolveLocationStopName = (index: number, locationCount: number, tFunc: any) => {
  if (index == 0) return tFunc('global.route.begin');
  if (index - 1 == locationCount) return tFunc('global.route.end');

  return tFunc('global.route.stop', { count: index + 1 });
};

/**
 * Used to show "Ceka se na nakladku/vykladku, Nalozeno v XXX, Vylozeno XXX
 */
export const resolveLoadingUnloadingStateText = (
  isCompletedLocation: boolean,
  completedAt: string,
  loadingActionIsFinished: boolean,
  loadingActionFinishedAt: string,
  loadingActionFinishedAtUtc: string,
  unloadingActionIsFinished: boolean,
  unloadingActionFinishedAt: string,
  unloadingActionFinishedAtUtc: string,
  timezoneId: string,
  t: any,
): string => {
  if (isNullOrUndefined(loadingActionIsFinished) && isNullOrUndefined(unloadingActionIsFinished)) {
    // only confirm both
    if (isCompletedLocation) {
      const completed = isNotNullOrUndefined(timezoneId)
        ? formatDateTimeFromDayjsInTzWithLocale(dayjsFromApiUtcInTz(completedAt, timezoneId), timezoneId)
        : stringDateTimeWithLocaleFromApiStringInTz(completedAt, 'Europe/Prague');
      console.log("resolveLoadingUnloadingStateText completed: ", completed, " from string: ", completedAt);
      return t('TabCarrierActive.bothFinishedWithTz', {
        date: completed,
      });
    } else {
      return t('TabCarrierActive.bothNotFinished');
    }
  }

  if (isNullOrUndefined(loadingActionIsFinished) && !isNullOrUndefined(unloadingActionIsFinished)) {
    // only unloading
    if (isCompletedLocation) {
      const unloadingFinishedAt =
        isNotNullOrUndefined(timezoneId) && isNotNullOrUndefined(unloadingActionFinishedAtUtc)
          ? formatDateTimeFromDayjsInTzWithLocale(
              dayjsFromApiUtcInTz(unloadingActionFinishedAtUtc, timezoneId),
              timezoneId,
            )
          : stringDateTimeWithLocaleFromApiStringInTz(unloadingActionFinishedAt, 'Europe/Prague');
      console.log("resolveLoadingUnloadingStateText unloadingFinishedAt: ", unloadingFinishedAt, " from string: ", unloadingFinishedAt, " from string utc:", unloadingActionFinishedAtUtc);
      return t('TabCarrierActive.unloadingFinishedWithTz', {
        date: unloadingFinishedAt,
      });
    } else {
      return t('TabCarrierActive.unloadingNotFinished');
    }
  }

  if (!isNullOrUndefined(loadingActionIsFinished) && isNullOrUndefined(unloadingActionIsFinished)) {
    // only loading
    const loadingFinishedAt =
      isNotNullOrUndefined(timezoneId) && isNotNullOrUndefined(loadingActionFinishedAtUtc)
        ? formatDateTimeFromDayjsInTzWithLocale(
            dayjsFromApiUtcInTz(loadingActionFinishedAtUtc, timezoneId),
            timezoneId,
          )
        : stringDateTimeWithLocaleFromApiStringInTz(loadingActionFinishedAt, 'Europe/Prague');
    console.log("resolveLoadingUnloadingStateText loadingFinishedAt: ", loadingFinishedAt, " from string: ", loadingActionFinishedAt, " from string utc:", loadingActionFinishedAtUtc);
    if (isCompletedLocation) {
      return t('TabCarrierActive.loadingFinishedWithTz', {
        date: loadingFinishedAt,
      });
    } else {
      return t('TabCarrierActive.loadingNotFinished');
    }
  }

  if (!isNullOrUndefined(loadingActionIsFinished) && !isNullOrUndefined(unloadingActionIsFinished)) {
    // loading and unloading
    if (isCompletedLocation) {
      const completed = isNotNullOrUndefined(timezoneId)
        ? formatDateTimeFromDayjsInTzWithLocale(dayjsFromApiUtcInTz(completedAt, timezoneId), timezoneId)
        : stringDateTimeWithLocaleFromApiStringInTz(completedAt, 'Europe/Prague');
      console.log("resolveLoadingUnloadingStateText completed2: ", completed, " from string: ", completedAt);
      return t('TabCarrierActive.loadingAndUnloadingFinished', {
        date: completed,
      });
    } else {
      return t('TabCarrierActive.loadingUnloadingNotFinished');
    }
  }
};
